import { forwardRef } from 'react'

type SpinnerSize = 'sm' | 'md' | 'lg'

export interface SpinnerProps {
  size?: SpinnerSize
  className?: string
}

const sizeStyles: Record<SpinnerSize, string> = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-10 w-10',
}

export const Spinner = forwardRef<SVGSVGElement, SpinnerProps>(
  function Spinner({ size = 'md', className = '' }, ref) {
    return (
      <svg
        ref={ref}
        className={`animate-spin text-[var(--color-accent)] ${sizeStyles[size]} ${className}`}
        fill="none"
        viewBox="0 0 24 24"
        role="status"
        aria-live="polite"
        aria-label="Loading"
        data-testid="spinner"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
        />
      </svg>
    )
  },
)
